import { createAction } from 'redux-actions'

export const setOrdersModal = createAction('ORDER/SET_CURRENT_MODAL')
